import React from "react";
import { GraduationCap, Briefcase, Compass, ArrowLeft } from "lucide-react";

const PATHS = [
  {
    id: "student",
    icon: GraduationCap,
    title: "إقامة الطالب",
    desc: "للأشخاص الذين يدرسون في بولندا أو يستعدون لتقنين الإقامة على أساس الدراسة.",
    bullets: [
      "مراجعة شروط إقامة الطالب",
      "تجهيز قائمة المستندات المطلوبة",
      "تحديد أفضل توقيت للتقديم",
    ],
    testid: "path-student",
  },
  {
    id: "work",
    icon: Briefcase,
    title: "إقامة العمل",
    desc: "لمن يعملون في بولندا أو يخططون لتقنين إقامتهم على أساس العمل.",
    bullets: [
      "تقييم عقد العمل والشروط",
      "كشف الثغرات في ملف العمل",
      "الخطوات الصحيحة للتقديم",
    ],
    testid: "path-work",
  },
  {
    id: "other",
    icon: Compass,
    title: "حالات إقامة أخرى",
    desc: "لمن لا ينطبق عليهم مسار الطالب أو العمل فقط ويحتاجون تأهيل حالتهم أولاً.",
    bullets: [
      "تحليل وضعك الخاص",
      "اختيار أنسب مسار ممكن",
      "تجنّب القرارات الخاطئة",
    ],
    testid: "path-other",
  },
];

export default function Paths() {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="paths"
      className="py-20 lg:py-24 bg-white border-y border-slate-100"
      data-testid="paths-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-start max-w-2xl mb-12">
          <div className="text-emerald-700 text-sm font-semibold mb-3">
            اختر مسارك
          </div>
          <h2 className="font-tajawal text-3xl sm:text-4xl font-bold text-slate-900 leading-tight">
            أيّ حالة تنطبق على وضعك؟
          </h2>
          <p className="mt-3 text-base md:text-lg text-slate-600">
            اختر أقرب وصف لوضعك الحالي، وسنوجّهك إلى الخطوة الصحيحة بدون
            تخمين.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {PATHS.map((p) => {
            const Icon = p.icon;
            return (
              <article
                key={p.id}
                className="group bg-white border border-slate-200 rounded-2xl p-7 lg:p-8 shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all flex flex-col"
                data-testid={`${p.testid}-card`}
              >
                <div className="w-12 h-12 rounded-xl bg-emerald-50 text-emerald-700 flex items-center justify-center mb-5">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="font-tajawal text-xl font-bold text-slate-900 mb-2">
                  {p.title}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-5">
                  {p.desc}
                </p>
                <ul className="space-y-2.5 mb-7">
                  {p.bullets.map((b, i) => (
                    <li
                      key={i}
                      className="flex items-start gap-2.5 text-sm text-slate-700"
                    >
                      <span className="mt-2 w-1.5 h-1.5 rounded-full bg-emerald-600 flex-shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
                <button
                  type="button"
                  onClick={() => scrollTo("#lead-form")}
                  className="mt-auto inline-flex items-center justify-center gap-2 bg-slate-900 hover:bg-slate-800 text-white rounded-xl px-5 py-3 font-semibold transition-colors"
                  data-testid={`${p.testid}-cta`}
                >
                  هذه حالتي
                  <ArrowLeft className="w-4 h-4" />
                </button>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
